import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


function TestimonialSlider() {
    const settings = {
        dots: true,
        arrows:false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
      };
  return (
    <div>
    <section className="section-padding thm-bg-light">
        <div className="container">
            <div className="section-header">
                <p className="section_count"></p>
                <h3 className="title">Our Happy Clients</h3>
            </div>
            <Slider {...settings} className="row testimonial_slider">
                <div className="col-12">
                    <div className="testimonial_item">
                        <div className="testimonial_image">
                            <img src="/tm/react/roboto/assets/images/testimonials/1.jpg" alt="img" className="image-fit"/>
                        </div>
                        <div className="testimonial_text">
                            <h4 className="title">Bratt Lee</h4>
                            <p className="post">Manager</p>
                            <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.</p>
                            <div className="ratings">
                                <i className="fas fa-star active"></i>
                                <i className="fas fa-star active"></i>
                                <i className="fas fa-star active"></i>
                                <i className="fas fa-star active"></i>
                                <i className="fas fa-star active"></i>
                            </div>
                        </div>
                    </div>
                </div>
               
                <div className="col-12">
                    <div className="testimonial_item">
                        <div className="testimonial_image">
                            <img src="/tm/react/roboto/assets/images/testimonials/2.jpg" alt="img" className="image-fit"/>
                        </div>
                        <div className="testimonial_text">
                            <h4 className="title">Jacks Kallis</h4>
                            <p className="post">Manager</p>
                            <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.</p>
                            <div className="ratings">
                                <i className="fas fa-star active"></i>
                                <i className="fas fa-star active"></i>
                                <i className="fas fa-star active"></i>
                                <i className="fas fa-star active"></i>
                                <i className="fas fa-star active"></i>
                            </div>
                        </div>
                    </div>
                </div>
               
                <div className="col-12">
                    <div className="testimonial_item">
                        <div className="testimonial_image">
                            <img src="/tm/react/roboto/assets/images/testimonials/3.jpg" alt="img" className="image-fit"/>
                        </div>
                        <div className="testimonial_text">
                            <h4 className="title">Jhon Deo</h4>
                            <p className="post">Manager</p>
                            <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.</p>
                            <div className="ratings">
                                <i className="fas fa-star active"></i>
                                <i className="fas fa-star active"></i>
                                <i className="fas fa-star active"></i>
                                <i className="fas fa-star active"></i>
                                <i className="fas fa-star"></i>
                            </div>
                        </div>
                    </div>
                </div>
               
                <div className="col-12">
                    <div className="testimonial_item">
                        <div className="testimonial_image">
                            <img src="/tm/react/roboto/assets/images/testimonials/4.jpg" alt="img" className="image-fit"/>
                        </div>
                        <div className="testimonial_text">
                            <h4 className="title">Robin Albert</h4>
                            <p className="post">Manager</p>
                            <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.</p>
                            <div className="ratings">
                                <i className="fas fa-star active"></i>
                                <i className="fas fa-star active"></i>
                                <i className="fas fa-star active"></i>
                                <i className="fas fa-star"></i>
                                <i className="fas fa-star"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </Slider>
        </div>
    </section>
    </div>
  )
}

export default TestimonialSlider